// The app's own Lambda: kitchen questions and the after-dinner debrief.
// Authenticated with the Meal Hat Firebase ID token; the Lambda verifies it
// against project `meal-hat` and nothing else.
import { authToken } from '../store/db.js';

const API_URL = (process.env.VUE_APP_API_URL || '').replace(/\/$/, '');

async function call (route, body) {
  if (!API_URL) throw new Error('The kitchen helper is not configured (VUE_APP_API_URL).');
  const token = await authToken();
  if (!token) throw new Error('Sign in first.');
  const response = await fetch(`${API_URL}${route}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify(body)
  });
  const text = await response.text();
  let data = null;
  try { data = text ? JSON.parse(text) : null; } catch { data = null; }
  if (!response.ok) throw new Error(data?.error || `The kitchen helper responded ${response.status}`);
  return data;
}

/** A question mid-cook. Returns { answer }. */
export const askQuestion = ({ lesson, stepIndex, question, history = [] }) =>
  call('/ask', {
    lessonId: lesson.id,
    lessonTitle: lesson.title,
    dish: lesson.dish,
    side: lesson.side,
    steps: lesson.steps.map((step) => step.text),
    mise: lesson.mise,
    stepIndex,
    question,
    history
  });

/** The after-dinner talk. Returns the structured summary. */
export const summarizeDebrief = ({ lesson, transcript, previous = [] }) =>
  call('/debrief', {
    lessonId: lesson.id,
    lessonTitle: lesson.title,
    dish: lesson.dish,
    side: lesson.side,
    prompt: lesson.debriefPrompt,
    transcript,
    previous
  });
